module.exports = __webpack_public_path__ + "img/barn.b2bd9392.webp";